var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{staticClass:"mr-1"},[_vm._v("mdi-check-all")]),_c('span',[_vm._v("Изменения сохранены. Вы можете уйти со страницы и продолжить отвечать позже.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }